import React, { useState, useEffect, useContext } from "react";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import { useNavigate } from "react-router-dom";
import { getRuta, simpleMessage } from "../../../helpers/Helpers";
import { getToken } from "../../../api/Account";
import { DataContext } from "../../../context/DataContext";
import { getVecidoCreditsAsync } from "../../../api/Dashboard";
import KpiCard from "../../../components/ui/KpiCard";

const VecidoCredits = ({ selectedSucursal }) => {
  const [vencidoCredits, setVencidoCredits] = useState(0);
  const { setIsLoading, setIsUnautorized } = useContext(DataContext);
  let ruta = getRuta();
  const token = getToken();
  let navigate = useNavigate();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getVecidoCreditsAsync(token, selectedSucursal);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);
      setVencidoCredits(result.data.result);
    })();
  }, [selectedSucursal]);

  return (
    <KpiCard
      onClick={() => navigate(`${ruta}/credits`)}
      icon={<ErrorRoundedIcon sx={{ fontSize: 20 }} />}
      iconBg="error.light"
      iconColor="error.main"
      value={vencidoCredits}
      label="Créditos vencidos"
    />
  );
};

export default VecidoCredits;
